import { memo } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { SwitchInput } from "@4uhub/lib4uhub";

const translationPath = "page.4uMarCom.automationRules.marcom_message.";

export const IsMoveHumanAttendant = memo(() => {
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={12} sm={12}>
        <SwitchInput
          name="isMoveHumanAttendant"
          label={t(translationPath + "isMoveHumanAttendant")}
        />
      </Grid>
    </>
  );
});
